import React, { useState } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "../style/login.css";
import { ROUTES } from "../Routes/routes";
import { PredefinedWord } from "../Routes/Predefined";
import { apiAxios } from "../utils/apiAxios";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const Forget: React.FC = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const trimmedEmail = email.trim();

    if (!trimmedEmail) {
      toast.warn("Please enter your registered email.");
      return;
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmedEmail)) {
      toast.warn("Please enter a valid email address.");
      return;
    }

    try {
      setLoading(true);
      const { data } = await apiAxios.post(
        `${API_BASE}/Users/forgot-password`, { email: trimmedEmail }
      );

      toast[data?.isSuccess ? "success" : "error"](data?.status || data?.message || "Something went wrong");
      if (data?.isSuccess) {
        setEmail("");
        setTimeout(() => navigate(ROUTES.LOGIN), 3000);
      }

    } catch {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };


  return (
    <div className="login-wrapper">
      {/* Background Animation */}
      <div className="login-bg">
        <motion.div
          className="bg-blob blob1"
          initial={{ scale: 0, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 1, delay: 0.2 }}
        />
        <motion.div
          className="bg-blob blob2"
          initial={{ scale: 0, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 1, delay: 0.4 }}
        />
        <motion.div
          className="bg-blob blob3"
          initial={{ scale: 0, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 1, delay: 0.6 }}
        />
      </div>

      {/* Main Box */}
      <motion.div
        className="login-box"
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
      >
        {/* Left Section */}
        <motion.div
          className="login-left"
          initial={{ x: -100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <h2>
            Forgot <span>Password?</span>
          </h2>
          <p>Enter your registered email to reset your password.</p>

          <form onSubmit={handleSubmit}>
            <div className="input-field">
              <i className="fa fa-envelope icon"></i>
              <input
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div className='d-flex gap-4'>
              <button type="submit" className="btn-login" disabled={loading}>
                {loading ? "Sending..." : "Submit"}
              </button>

              <div className="forgot mt-3">
                <a
                  onClick={() => navigate(ROUTES.LOGIN)}
                  className="text-decoration-none back-tologintext cursor-pointer"
                >
                  ← Back to Login
                </a>
              </div></div>
          </form>
        </motion.div>

        {/* Right Image Section */}
        <motion.div
          className="login-right"
          initial={{ x: 100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.4 }}
        >

          <span className="float-circle circle-1"></span>
          <span className="float-circle circle-2"></span>
          <span className="float-circle circle-3"></span>
          <span className="float-circle circle-4"></span>
          <span className="float-circle circle-5"></span>
          <span className="float-circle circle-6"></span>
          <span className="float-circle circle-7"></span>
          <span className="float-circle circle-8"></span>

          <img src={PredefinedWord.images.rightbgimage} alt={PredefinedWord.images.rightbgimagealt} className="login-image" />
        </motion.div>
      </motion.div>
    </div>
  );
};

export default Forget;